import axios from "axios";
import axiosRetry from 'axios-retry';
import { MAX_HTTP_CALL_RETRY } from "../utils";
import { ErrorCodes } from "../types";
export const createAxiosInstance = (baseUrl) => {
    const axiosInstance = axios.create({
        baseURL: baseUrl,
        headers: { "Content-Type": "application/json" },
    });
    axiosRetry(axiosInstance, {
        retries: MAX_HTTP_CALL_RETRY,
        retryDelay: (retryCount) => 1000 * retryCount, // 1s, 2s, 3s
        retryCondition: (error) => {
            return (axiosRetry.isNetworkError(error) ||
                axiosRetry.isRetryableError(error) ||
                (error.response ? error.response.status === ErrorCodes.notFound : false) ||
                (error.response ? error.response.status >= ErrorCodes.internalServerError : false));
        }
    });
    return axiosInstance;
};
//# sourceMappingURL=axios.js.map